import gql from "graphql-tag";

export const DeleteActivity = gql`
  mutation DeleteActivity($id: [String!]!) {
    deleteActivities(ids: $id)
  }
`;
